"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.SelectedCount = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var icon_checkbox_blue_svg_1 = __importDefault(require("../../assets/images/icon-checkbox-blue.svg"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var utils_1 = require("../../utils");
var Common_1 = require("../Common");
var CounterPill_1 = require("../CounterPill");
var Loading_1 = require("../Loading");
var SearchBox_1 = __importDefault(require("../Search/SearchBox"));
var SelectOption_1 = require("./SelectOption");
var SelectOptionGroup_1 = require("./SelectOptionGroup");
var SelectSharedComponents_1 = require("./SelectSharedComponents");
var SelectStyles_1 = require("./SelectStyles");
var SelectUtil_1 = require("./SelectUtil");
// SELECT ALL CONTAINER
var SelectAllContainer = styled_components_1.default.div.attrs({
    className: 'selectall-container tws-select-all-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-size: ", ";\n\tborder-bottom: ", " ", " ", ";\n\t.custom-control {\n\t\tpadding: 15px 16px 15px 40px;\n\t\theight: 46px;\n\t\tline-height: 1.2em;\n\t\t&:focus {\n\t\t\toutline: 0;\n\t\t}\n\t}\n\t", "\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.custom-control.custom-checkbox:hover {\n\t\t\tcursor: pointer;\n\t\t\t.custom-control-input ~ .custom-control-label::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t\t.custom-control-input:checked ~ .custom-control-label::after {\n\t\t\t\tbackground-image: url(", ") !important;\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tfont-size: ", ";\n\tborder-bottom: ", " ", " ", ";\n\t.custom-control {\n\t\tpadding: 15px 16px 15px 40px;\n\t\theight: 46px;\n\t\tline-height: 1.2em;\n\t\t&:focus {\n\t\t\toutline: 0;\n\t\t}\n\t}\n\t", "\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.custom-control.custom-checkbox:hover {\n\t\t\tcursor: pointer;\n\t\t\t.custom-control-input ~ .custom-control-label::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t\t.custom-control-input:checked ~ .custom-control-label::after {\n\t\t\t\tbackground-image: url(", ") !important;\n\t\t\t}\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.fontSizeSmall, globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2, function (props) {
    return props.checked
        ? "\n\t\t.custom-control-label::before {\n\t\t\tbackground-color: ".concat(globalVars_module_scss_1.default.mainBlue, ";\n\t\t\tborder-color: ").concat(globalVars_module_scss_1.default.white, ";\n\t\t}\n\t\t.custom-control-label::after {\n\t\t\tborder-radius: 2px;\n\t\t}\n\t\t")
        : null;
}, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, icon_checkbox_blue_svg_1.default);
SelectAllContainer.displayName = 'SelectAllContainer';
// SELECT COUNT
exports.SelectedCount = styled_components_1.default.div.attrs({
    className: 'selected-count tws-select-count',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-right: 8px;\n\t", "\n"], ["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-right: 8px;\n\t", "\n"])), globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, function (props) { return (0, SelectStyles_1.selectCountStyles)(props.size); });
exports.SelectedCount.displayName = 'SelectedCount';
// OPTION ITEM: SELECT
var SelectOptionItem = (0, styled_components_1.default)(SelectOption_1.SelectOption).attrs({
    className: 'options-item tws-select-options-item',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
SelectOptionItem.displayName = 'SelectOptionItem';
var SelectedItemCountContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding-right: 10px;\n\talign-self: center;\n\tdisplay: flex;\n"], ["\n\tpadding-right: 10px;\n\talign-self: center;\n\tdisplay: flex;\n"])));
var ItemWithCountContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: flex;\n\tposition: relative;\n"], ["\n\tdisplay: flex;\n\tposition: relative;\n"])));
var ItemWithCountContainerItem = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tflex: 1;\n"], ["\n\tflex: 1;\n"])));
var ItemWithCountContainerCount = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-top: -6px;\n\tposition: absolute;\n\tright: 16px;\n"], ["\n\tmargin-top: -6px;\n\tposition: absolute;\n\tright: 16px;\n"])));
var LoadingContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\ttop: 80px;\n\tposition: relative;\n"], ["\n\ttop: 80px;\n\tposition: relative;\n"])));
LoadingContainer.displayName = 'LoadingContainer';
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = false;
        // Hold the original selected values, need to revert back the selected values if onblur
        _this.originalSelectedValues = [];
        _this.getDisplayText = function () {
            var _a = _this.props, keepDisplayText = _a.keepDisplayText, multiple = _a.multiple, showRadioButton = _a.showRadioButton;
            var _b = _this.state, items = _b.items, selectedValue = _b.selectedValue, selectedValues = _b.selectedValues;
            var displayText = _this.props.displayText;
            // Do not update display text when any value was selected and keepDisplayText was set to true
            if (!keepDisplayText && !multiple && !showRadioButton && selectedValue) {
                var selectedItem = lodash_1.default.find(items, { name: selectedValue });
                if (selectedItem) {
                    displayText = selectedItem.selectedDisplayText ? selectedItem.selectedDisplayText : selectedItem.displayText;
                }
            }
            if (selectedValues && selectedValues.length > 0) {
                displayText = _this.state.displayText;
            }
            return displayText;
        };
        _this.state = {
            items: _this.props.items ? __spreadArray([], _this.props.items, true) : [],
            open: false,
            displayText: _this.props.displayText,
            selectedValue: _this.props.selectedValue || '',
            selectedValues: _this.props.selectedValues || [],
            allSelected: false,
            singleSelected: false,
        };
        _this.originalSelectedValues = lodash_1.default.cloneDeep(_this.state.selectedValues);
        _this.originalList = lodash_1.default.cloneDeep(_this.state.items);
        _this.groupSearches = new Map();
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnFocus = _this.handleOnFocus.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleSelectAll = _this.handleSelectAll.bind(_this);
        _this.handleRadioButtonChange = _this.handleRadioButtonChange.bind(_this);
        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
        _this.onApply = _this.onApply.bind(_this);
        _this.updateSearch = _this.updateSearch.bind(_this);
        _this.updateGroupSearch = _this.updateGroupSearch.bind(_this);
        _this.getSelectedItemCount = _this.getSelectedItemCount.bind(_this);
        _this.selectionRef = React.createRef();
        return _this;
    }
    Select.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            selectedValue: nextProps.selectedValue || '',
            selectedValues: nextProps.selectedValues || [],
            items: nextProps.items ? nextProps.items : [],
            initialSearchText: nextProps.initialSearchText,
        });
        this.originalSelectedValues = lodash_1.default.cloneDeep(nextProps.selectedValues);
    };
    Select.prototype.componentWillUnmount = function () {
        this.clearFocusTime();
        this.clearBlurTime();
    };
    Select.prototype.updateSearch = function (searchText) {
        var filteredItems = this.state.items;
        if (searchText === '') {
            filteredItems = this.originalList;
        }
        else {
            filteredItems = lodash_1.default.filter(this.originalList, function (option) {
                return utils_1.MatchingUtil.testObjectMatch(option, searchText, ['name', 'displayText']);
            });
        }
        // refresh the dropdown list
        this.setState({ items: filteredItems, initialSearchText: searchText });
        if (this.props.showRadioButton) {
            // TO DO - handling radio button dropdown for filtering and clearing
            // console.log('have radio');
            // this.radioItems = updatedItems;
            // this.setState({radioItems: updatedItems});
        }
    };
    Select.prototype.updateGroupSearch = function (searchText, group) {
        var filteredItems = this.state.items;
        if (searchText === '') {
            filteredItems = this.originalList;
        }
        else {
            // return all items not in the group AND items matching search
            filteredItems = lodash_1.default.filter(this.originalList, function (option) {
                return option.group !== group || utils_1.MatchingUtil.testObjectMatch(option, searchText, ['name', 'displayText']);
            });
        }
        this.groupSearches[group] = searchText;
        // refresh the dropdown list
        this.setState({ items: filteredItems });
        if (this.props.showRadioButton) {
            // TO DO - handling radio button dropdown for filtering and clearing
            // console.log('have radio');
            // this.radioItems = updatedItems;
            // this.setState({radioItems: updatedItems});
        }
    };
    Select.prototype.render = function () {
        var selectedCount = this.props.showCount && this.originalSelectedValues ? this.originalSelectedValues.length : 0;
        var selectedItemCount = this.getSelectedItemCount();
        return (React.createElement(React.Fragment, null,
            React.createElement(SelectSharedComponents_1.Container, { className: this.props.className, tabIndex: 0, ref: this.selectionRef, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), onBlur: this.handleOnBlur, onFocus: this.handleOnFocus },
                React.createElement(SelectSharedComponents_1.SelectContainer, { "aria-expanded": this.state.open, "aria-label": this.props.displayText, onClick: this.toggleDropdown, selectWidth: this.props.selectWidth, size: this.props.size, selectSize: this.props.selectSize, disabled: this.props.disabled, focus: this.focus, error: this.props.error, selectedState: this.checkSingleSelect() },
                    React.createElement(SelectSharedComponents_1.DisplayText, null, this.getDisplayText()),
                    this.props.showCount && React.createElement(exports.SelectedCount, { size: this.props.size },
                        "(",
                        selectedCount,
                        ")"),
                    selectedItemCount != null && (React.createElement(SelectedItemCountContainer, null,
                        React.createElement(CounterPill_1.CounterPill, { size: 'lg', actualCount: selectedItemCount }))),
                    React.createElement(SelectSharedComponents_1.SelectToggle, { disabled: this.props.disabled, focus: this.focus, size: this.props.size },
                        React.createElement(Common_1.Icon, { name: 'caret-down' }))),
                this.generateDropdown()),
            this.props.message && this.getExtraMessage(),
            this.props.warnings && Common_1.MessageHelper.getFormattedWarningMessages(this.props.warnings)));
    };
    // Check if single select has a selected value and change the bg color
    Select.prototype.checkSingleSelect = function () {
        if (this.props.selectedValue !== '' && this.props.disabled !== true) {
            if (this.state.singleSelected || this.props.multiple !== true) {
                return true;
            }
            return false;
        }
        else {
            return false;
        }
    };
    Select.prototype.getExtraMessage = function () {
        if (this.props.message) {
            if (this.props.error) {
                return Common_1.MessageHelper.getFormattedErrorMessages(this.props.message);
            }
            if (this.props.success) {
                return Common_1.MessageHelper.getFormattedSuccessMessages(this.props.message);
            }
        }
        return null;
    };
    Select.prototype.generateDropdown = function () {
        if (!this.state.open) {
            return React.createElement("span", null);
        }
        else if (this.props.isLoading) {
            return this.generateLoadingContainer();
        }
        var applyButton = this.props.multiple || this.props.showApplyButton;
        return (React.createElement(SelectSharedComponents_1.DropdownContainer, { optionsContainerWidth: this.props.optionsContainerWidth, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), dropdownSize: this.props.dropdownSize },
            this.props.showSelectAll && (React.createElement(SelectAllContainer, { checked: this.state.allSelected },
                React.createElement(Common_1.Checkbox, { label: this.props.selectAllText, size: 'sm', checked: this.state.allSelected, onChange: this.handleSelectAll }))),
            this.props.showSearch && !this.props.hasGroups && (React.createElement(SelectSharedComponents_1.SearchBoxContainer, null,
                React.createElement(SearchBox_1.default, { callbackFunc: this.updateSearch, inputSize: 'sm', resultsCount: this.state.items.length, initialSearchText: this.state.initialSearchText, placeHolderText: this.props.placeHolderText }))),
            React.createElement(SelectSharedComponents_1.OptionsContainer, { applyButton: applyButton, showSearch: this.props.showSearch, hasGroups: this.props.hasGroups, showSelectAll: this.props.showSelectAll }, this.generateOptions()),
            applyButton && (React.createElement(SelectSharedComponents_1.ApplyButtonContainer, null,
                React.createElement(SelectSharedComponents_1.ApplyButton, { size: 'sm', color: 'primary', block: true, onClick: this.onApply }, this.props.applyText ? this.props.applyText : 'Apply')))));
    };
    Select.prototype.generateLoadingContainer = function () {
        return (React.createElement(SelectSharedComponents_1.LoadingDropdownContainer, { optionsContainerWidth: this.props.optionsContainerWidth, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), dropdownSize: this.props.dropdownSize, selectSize: 'lg' },
            React.createElement(LoadingContainer, null,
                React.createElement(Loading_1.Loading, { height: '40px', width: '40px' }))));
    };
    // Generate option items
    Select.prototype.generateOptions = function () {
        var _this = this;
        if (this.props.showRadioButton) {
            var radioOptions = this.state.items.map(function (item) {
                return {
                    name: item.name,
                    displayText: item.displayText,
                };
            });
            return (React.createElement(SelectOptionItem, null,
                React.createElement(Common_1.Radio, { items: radioOptions, size: 'sm', value: this.state.selectedValue, onChange: this.handleRadioButtonChange })));
        }
        else {
            var groups = this.originalList.reduce(function (carry, item) {
                if (item.group && lodash_1.default.filter(carry, { group: item.group }).length === 0) {
                    carry.push({ group: item.group, groupOrder: item.groupOrder });
                }
                return carry;
            }, []);
            // render groups
            if (groups.length > 0) {
                var orderedGroups = lodash_1.default.orderBy(groups, ['groupOrder'], ['asc']);
                return orderedGroups.map(function (group, index) {
                    var options = lodash_1.default.filter(_this.state.items, { group: group.group });
                    options = lodash_1.default.orderBy(options, ['displayOrder'], ['asc']);
                    var names = options.map(function (item) { return item.name; });
                    var selectCount = lodash_1.default.intersection(names, _this.state.selectedValues).length;
                    return (React.createElement(SelectOptionGroup_1.SelectOptionGroup, { selectedCount: selectCount, searchBox: _this.props.hasGroups, group: group.group, key: "group-".concat(index), collapsed: index > 0, updateSearch: _this.updateGroupSearch, initialSearchText: _this.groupSearches[group.group] || '', placeHolderText: _this.props.placeHolderText }, options.map(function (item) {
                        return (React.createElement(SelectOptionItem, { item: item, selected: _this.isSelected(item.name), onChange: _this.handleOnChange, key: item.name }, _this.generateOptionItem(item)));
                    })));
                });
            }
            else {
                var options = lodash_1.default.orderBy(this.state.items, ['displayOrder'], ['asc']);
                return options.map(function (item) { return (React.createElement(SelectOptionItem, { item: item, selected: _this.isSelected(item.name), onChange: _this.handleOnChange, key: item.name }, _this.generateOptionItem(item))); });
            }
        }
    };
    // Generate single option item(Checkbox/Text)
    Select.prototype.generateOptionItem = function (item) {
        var _this = this;
        var getSelectContent = function () {
            if (_this.props.multiple) {
                return (React.createElement(Common_1.Checkbox, { size: 'sm', label: item.displayText, disabled: item.disabled, checked: _this.isSelected(item.name), id: item.name }));
            }
            return item.displayText;
        };
        if (item.count != null) {
            return (React.createElement(ItemWithCountContainer, null,
                React.createElement(ItemWithCountContainerItem, null, getSelectContent()),
                React.createElement(ItemWithCountContainerCount, null,
                    React.createElement(CounterPill_1.CounterPill, { size: 'lg', actualCount: item.count }))));
        }
        return React.createElement("div", null, getSelectContent());
    };
    Select.prototype.getSelectedItemCount = function () {
        if (this.state.selectedValue) {
            var selectedItem = lodash_1.default.find(this.state.items, { name: this.state.selectedValue });
            if (selectedItem) {
                return selectedItem.count;
            }
        }
        return undefined;
    };
    Select.prototype.handleOnChange = function (item, selected) {
        var keepDisplayText = this.props.keepDisplayText;
        if (this.props.multiple || this.props.showApplyButton) {
            if (selected) {
                this.setState({ selectedValues: __spreadArray(__spreadArray([], this.state.selectedValues, true), [item.name], false) });
            }
            else {
                var index = lodash_1.default.indexOf(this.state.selectedValues, item.name);
                if (index > -1) {
                    var values = __spreadArray(__spreadArray([], this.state.selectedValues.slice(0, index), true), this.state.selectedValues.slice(index + 1, this.state.items.length), true);
                    this.setState({ selectedValues: values });
                }
            }
        }
        else {
            // Single selection mode
            if (this.props.onApply) {
                this.props.onApply(item.name, this.state.items);
            }
            this.setState({ selectedValue: item.name });
            this.setState({ singleSelected: true });
            // Do not update the display text if keepDisplayText was set to true
            if (!keepDisplayText) {
                this.setState({ displayText: item.displayText });
            }
            this.setOpenState(false);
            if (this.selectionRef && this.selectionRef.current) {
                this.selectionRef.current.blur();
            }
        }
    };
    // function should only be called by the click event on the Apply button
    Select.prototype.onApply = function () {
        if (this.props.maxDisplayItems) {
            var displayText = '';
            if (this.state.selectedValues.length > 0) {
                displayText = this.state.selectedValues.slice(0, this.props.maxDisplayItems).join(',');
                if (this.props.maxDisplayItems < this.state.selectedValues.length) {
                    displayText += '...';
                }
            }
            this.setState({ displayText: displayText });
        }
        this.props.onApply(this.props.multiple ? this.state.selectedValues : this.state.selectedValue, this.state.items);
        this.originalSelectedValues = lodash_1.default.cloneDeep(this.state.selectedValues);
        this.setOpenState(false, false);
    };
    Select.prototype.handleRadioButtonChange = function (value) {
        this.setState({ selectedValue: value });
    };
    // function should only be called by the click event on the select container
    Select.prototype.toggleDropdown = function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        this.setOpenState(!this.state.open, !this.state.open);
    };
    Select.prototype.setOpenState = function (open, needFocus) {
        var _this = this;
        if (this.state.open === open) {
            this.maybeFocus(open, needFocus);
            return;
        }
        if (this.props.onDropdownVisibleChange) {
            this.props.onDropdownVisibleChange(open);
        }
        if (!open) {
            this.maybeFocus(open, needFocus);
        }
        this.focus = open;
        var nextState = {
            open: open,
        };
        this.setState(nextState, function () {
            if (open) {
                _this.maybeFocus(open, needFocus);
            }
        });
    };
    Select.prototype.maybeFocus = function (open, needFocus) {
        var _this = this;
        if (needFocus || open) {
            var activeElement = document.activeElement;
            if (this.selectionRef && activeElement !== this.selectionRef) {
                this.focusTimer = setTimeout(function () {
                    _this.selectionRef.current.focus();
                    _this.focus = true;
                }, 10);
            }
        }
    };
    Select.prototype.timeoutFocus = function () {
        var _this = this;
        if (this.focusTimer) {
            this.clearFocusTime();
        }
        if (this.props.onFocus) {
            this.focusTimer = setTimeout(function () {
                _this.props.onFocus();
            }, 10);
        }
    };
    Select.prototype.clearFocusTime = function () {
        if (this.focusTimer) {
            clearTimeout(this.focusTimer);
            this.focusTimer = null;
        }
    };
    Select.prototype.clearBlurTime = function () {
        if (this.blurTimer) {
            clearTimeout(this.blurTimer);
            this.blurTimer = null;
        }
    };
    Select.prototype.handleOnBlur = function () {
        var _this = this;
        this.blurTimer = setTimeout(function () {
            _this.setState({ selectedValues: _this.originalSelectedValues });
            _this.setOpenState(false, false);
        }, 10);
    };
    Select.prototype.handleOnFocus = function (e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        this.clearBlurTime();
        this.timeoutFocus();
    };
    Select.prototype.isSelected = function (name) {
        if (!this.props.multiple) {
            return this.state.selectedValue === name;
        }
        else {
            return this.state.selectedValues.indexOf(name) > -1;
        }
    };
    Select.prototype.handleSelectAll = function (e) {
        var values = [];
        if (e.target.checked) {
            values = this.state.items.filter(function (item) { return !item.disabled; }).map(function (item) { return item.name; });
        }
        this.setState({ selectedValues: values, allSelected: !this.state.allSelected });
    };
    // Default props
    Select.defaultProps = {
        selectWidth: 'auto',
        selectAllText: 'Select All',
        optionsContainerWidth: '100%',
    };
    return Select;
}(React.Component));
exports.Select = Select;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
